export var ApiProduct;
(function (ApiProduct) {
    ApiProduct["ILE"] = "ILE";
    ApiProduct["Spanish"] = "Spanish";
    ApiProduct["Enyay"] = "Enyay";
    ApiProduct["IM"] = "IM";
    ApiProduct["IMF"] = "IMF";
    ApiProduct["Galileo"] = "Galileo";
    ApiProduct["MyPathMath"] = "MyPathMath";
    ApiProduct["MyPathReading"] = "MyPathReading";
    ApiProduct["Purpose"] = "Purpose";
    ApiProduct["Traverse"] = "Traverse";
    ApiProduct["IPA"] = "IPA";
    ApiProduct["DrSeuss"] = "DrSeuss";
    ApiProduct["Dragonfly"] = "Dragonfly";
    ApiProduct["StudySync"] = "StudySync";
    ApiProduct["TwigScienceK6"] = "TwigScienceK6";
    ApiProduct["TwigScienceMS"] = "TwigScienceMS";
    ApiProduct["ImagineIM"] = "ImagineIM";
    ApiProduct["IllustrativeMathematics"] = "IllustrativeMathematics";
    ApiProduct["ELEducation"] = "ELEducation";
    ApiProduct["Guidebooks"] = "Guidebooks";
    ApiProduct["OdellEducation"] = "OdellEducation";
    ApiProduct["Other"] = "Other";
    ApiProduct["None"] = "None";
    ApiProduct["Any"] = "Any";
})(ApiProduct || (ApiProduct = {}));
